<div class="business-info-cancellation" [mmTestId]="'ADD_BUSINESS_INFO.CANCELLATION_DIALOG'">
  <mm-dialog-title>
    {{ 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.CANCELLATION_DIALOG.TITLE' | translate }}
  </mm-dialog-title>

  <mm-dialog-content>
    {{ 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.CANCELLATION_DIALOG.TEXT' | translate }}
  </mm-dialog-content>

  <mm-dialog-footer>
    <button mm-button
            class="business-info-cancellation__submit-button"
            color="ghost"
            [mmDialogClose]="true"
            [mmTestTarget]="'proceed-as-consumer-button'">
      {{ 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.CANCELLATION_DIALOG.SUBMIT' | translate }}
    </button>
    <button mm-button
            class="business-info-cancellation__cancel-button"
            mmDialogClose
            [mmTestTarget]="'add-business-info-button'">
      {{ 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.CANCELLATION_DIALOG.CANCEL' | translate }}
    </button>
  </mm-dialog-footer>
</div>
